import React from 'react';
import { Button } from 'primereact/button';

const DeleteButton = ({ rowData, setDeleteRow }) => {
  const handleClick = () => {
    setDeleteRow(rowData);
  };

  return <Button link onClick={handleClick} icon={'pi pi-trash'} />;
};

export default React.memo(DeleteButton);
